import { useRecordContext } from "react-admin";
import ReturnCorrectionModal from "components/CareerCenter/Partials/ReturnCorrectionModal";
import { alumniRequests } from "api/alumniApi";

const ReturnAlumniProfileForCorrection = () => {
  const record = useRecordContext();

  return <ReturnCorrectionModal correctionsUrl={alumniRequests.returnForCorrectionAlumniProfile(record?.id)} />;
};

export default ReturnAlumniProfileForCorrection;
